import { Text, View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import { CButton, CInput } from '@app/components/Common';
import { Button, Input, Select } from 'antd';
import BigNumber from 'bignumber.js';
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../../../../../constants';
import { SETTING_TYPE_TRADE } from '../../../../../../constants/SETTING';
import { useIndexPrice } from '../../../../../../hooks/trade/indexprice';
import useTradeStore from '../../../../../../hooks/trade/tradeStore';
import { getSetting, useSetting } from '../../../../../../hooks/user/mysetting';
import { OrderValueInputSection } from '../styles';

const OrderPriceInput = ({ limit_market, isManualInputRef, isMobile }) => {
  const { textw, gray, drawerBgColor, mobileTradeBorder, textsilver } =
    React.useContext(ThemeContext).theme.COLORS;
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';

  const { t } = useTranslation();
  const { data: tradeStore, mutate: mutateTradeStore } = useTradeStore();
  const { getPrice } = useIndexPrice(tradeStore?.ep_id);

  const { data: setting, updateSetting } = useSetting(SETTING_TYPE_TRADE);
  const alarm = getSetting(setting, 'ALM' + tradeStore?.ep_id, 0);

  const [trigger, setTrigger] = React.useState('BIG');

  useEffect(() => {
    if (
      tradeStore?.order_price === undefined ||
      tradeStore?.order_price === '' ||
      isNaN(tradeStore?.order_price) ||
      tradeStore?.order_price == 0
    ) {
      const price = getPrice(tradeStore?.ep_id);
      if (price) {
        mutateTradeStore({
          ...tradeStore,
          order_price: BigNumber(price).toFixed(tradeStore?.dp || 3),
        });
      }
    }
  }, [tradeStore, getPrice, mutateTradeStore]);

  const setOrderPrice = (data) => {
    if (isNaN(data)) return;
    mutateTradeStore({ ...tradeStore, order_price: data });
  };
  const setTriggerPrice = (data) => {
    if (isNaN(data)) return;
    mutateTradeStore({
      ...tradeStore,
      trigger_price: data,
      trigger_type: trigger,
    });
  };

  const handleTriggerButton = (type: 'plus' | 'minus') => {
    if (type === 'plus') {
      setTriggerPrice(
        BigNumber(tradeStore?.trigger_price || 0)
          .plus(1)
          .toNumber()
      );
    } else {
      setTriggerPrice(
        BigNumber(tradeStore?.trigger_price || 0)
          .minus(1)
          .toNumber()
      );
    }
  };

  const [alm, setAlm] = React.useState(alarm);
  const [almp, setAlmp] = React.useState(alarm);

  return (
    <OrderValueInputSection>
      {(limit_market == 'T' ||
        limit_market == 'CL' ||
        limit_market == 'CM') && (
        <View
          style={{
            flexDirection: 'row',
            width: '100%',
            gap: 5,
            marginBottom: 10,
          }}
        >
          <Button
            style={{
              color: limit_market == 'CL' ? textw : 'silver',
              background: limit_market == 'CL' ? drawerBgColor : 'transparent',
              border: `0px`,
              borderRadius: 10,
              width: '50%',
              padding: '5px 0',
            }}
            onClick={() => {
              mutateTradeStore({
                ...tradeStore,
                limit_market: 'CL',
              });
            }}
          >
            {t('limit')}
          </Button>
          <Button
            style={{
              color: limit_market == 'CM' ? textw : 'silver',
              background: limit_market == 'CM' ? drawerBgColor : 'transparent',
              border: `0px`,
              borderRadius: 10,
              width: '50%',
              padding: '5px 0',
            }}
            onClick={() => {
              mutateTradeStore({
                ...tradeStore,
                limit_market: 'CM',
              });
            }}
          >
            {t('market')}
          </Button>
        </View>
      )}

      {limit_market != 'CM' && (
        <>
          {isMobile ? (
            <div
              style={{
                background: gray,
                color: textw,
                border: `1px solid ${mobileTradeBorder}`,
                marginTop: 5,
                padding: `4px 12px`,
                width: '100%',
                backgroundColor: theme === 'light' ? '#F8F4F0' : '#0C110E',
                display: 'flex',
                justifyContent: 'space-between',
                gap: 8,
                alignItems: 'center',
                borderRadius: 6,
              }}
            >
              <CButton
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '16px',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  setOrderPrice(
                    BigNumber(tradeStore?.order_price).minus(1).toNumber()
                  )
                }
                title={'-'}
              />
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 4,
                  alignItems: 'center',
                  flex: 1,
                }}
              >
                <span style={{ fontSize: 12, color: textsilver }}>
                  {t('price')} (USDT)
                </span>
                <Input
                  value={tradeStore?.order_price}
                  onChange={(e: any) => setOrderPrice(e.target.value)}
                  style={{
                    border: 'none',
                    textAlign: 'center',
                    padding: 0,
                    fontFamily: 'Binance PLEX',
                    background: 'transparent',
                  }}
                />
              </div>
              <CButton
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: '16px',
                  cursor: 'pointer',
                }}
                onClick={() =>
                  setOrderPrice(
                    BigNumber(tradeStore?.order_price).plus(1).toNumber()
                  )
                }
                title={'+'}
              />
            </div>
          ) : (
            <>
              <View style={{ flexDirection: 'row' }}>
                <Text
                  style={{
                    color: textw,
                    fontSize: 14,
                    marginBottom: 2,
                  }}
                >
                  {t('orderPrice')}
                </Text>
                {/*<Popover*/}
                {/*  trigger={"click"}*/}
                {/*  content={*/}
                {/*    <View>*/}
                {/*      <Space size={"small"}>*/}
                {/*        {t("alarmsetting")}*/}
                {/*        <Input*/}
                {/*          value={alm}*/}
                {/*          type={"number"}*/}
                {/*          onChange={(e: any) => {*/}
                {/*            setAlm(+e.target.value);*/}
                {/*          }}*/}
                {/*        />*/}
                {/*        <Button*/}
                {/*          onClick={() => {*/}
                {/*            updateSetting("ALM" + tradeStore?.ep_id, alm);*/}
                {/*            message.success(t("savedalarm"));*/}
                {/*          }}*/}
                {/*        >*/}
                {/*          {t("save")}*/}
                {/*        </Button>*/}
                {/*        <Button*/}
                {/*          onClick={() => {*/}
                {/*            updateSetting("ALM" + tradeStore?.ep_id, 0);*/}
                {/*            message.success(t("savedalarm"));*/}
                {/*          }}*/}
                {/*        >*/}
                {/*          {t("delete")}*/}
                {/*        </Button>*/}
                {/*      </Space>*/}
                {/*      <Space.Compact size="small">*/}
                {/*        <Slider*/}
                {/*          style={{ width: 350 }}*/}
                {/*          min={-10}*/}
                {/*          max={10}*/}
                {/*          onChange={(e: any) => {*/}
                {/*            setAlmp(e);*/}
                {/*            const price =*/}
                {/*              getPrice(tradeStore?.ep_id) * (1 + e / 100);*/}
                {/*            setAlm(price.toFixed(tradeStore?.dp || 3));*/}
                {/*          }}*/}
                {/*          value={almp}*/}
                {/*          marks={{*/}
                {/*            "-10": "-10%",*/}
                {/*            "-5": "-5%",*/}
                {/*            "-3": "-3%",*/}
                {/*            "-1": "-1%",*/}
                {/*            0: "0",*/}
                {/*            1: "1%",*/}
                {/*            3: "3%",*/}
                {/*            5: "5%",*/}
                {/*            10: "10%",*/}
                {/*          }}*/}
                {/*        />*/}
                {/*      </Space.Compact>*/}
                {/*    </View>*/}
                {/*  }*/}
                {/*>*/}
                {/*  <Button size="small" type="ghost" style={{ color: textw }}>*/}
                {/*    <IconAlarm size={20} style={{ marginTop: -4 }} color={textw} />*/}
                {/*    {alarm}*/}
                {/*  </Button>*/}
                {/*</Popover>*/}
              </View>
              <Input
                placeholder={''}
                value={tradeStore?.order_price ? tradeStore?.order_price : null}
                type={'text'}
                onChange={(e: any) => setOrderPrice(e.target.value)}
                style={{
                  background: gray,
                  color: textw,
                  border: `1px solid ${isMobile ? mobileTradeBorder : '#F87943'}`,
                  marginTop: 5,
                  padding: 10,
                  width: '100%',
                  backgroundColor: theme === 'light' ? '#F8F4F0' : '#0C110E',
                  marginBottom: 10,
                  cursor: 'pointer',
                }}
                suffix={
                  <CButton
                    title={t('lastprice')}
                    onClick={() => {
                      setOrderPrice(
                        BigNumber(getPrice(tradeStore?.ep_id)).toFixed(
                          tradeStore?.dp || 3
                        )
                      );
                    }}
                    style={{
                      fontSize: '12px',
                      color: COLORS.primary,
                    }}
                  />
                }
              />
            </>
          )}
        </>
      )}

      {(limit_market == 'T' || limit_market == 'CM' || limit_market == 'CL') &&
        (isMobile ? (
          <div
            style={{
              background: gray,
              color: textw,
              border: `1px solid ${mobileTradeBorder}`,
              padding: `4px 12px`,
              width: '100%',
              backgroundColor: theme === 'light' ? '#F8F4F0' : '#0C110E',
              display: 'flex',
              justifyContent: 'space-between',
              gap: 8,
              alignItems: 'center',
              borderRadius: 6,
              marginTop: 15,
            }}
          >
            <CButton onClick={() => handleTriggerButton('minus')} title={'-'} />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                alignItems: 'center',
                flex: 1,
              }}
            >
              <span style={{ fontSize: 12, color: textsilver }}>
                {t('triggerPrice')} (USDT)
              </span>
              <Input
                value={
                  tradeStore?.trigger_price ? tradeStore?.trigger_price : 0
                }
                type={'text'}
                onChange={(e: any) => setTriggerPrice(e.target.value)}
                style={{
                  border: 'none',
                  textAlign: 'center',
                  padding: 0,
                  fontFamily: 'Binance PLEX',
                  background: 'transparent',
                }}
              />
            </div>
            <CButton onClick={() => handleTriggerButton('plus')} title={'+'} />
          </div>
        ) : (
          <>
            <Text
              style={{
                color: textw,
                fontSize: 13,
                marginBottom: 3,
              }}
            >
              {t('triggerPrice')}
            </Text>
            {/* <View style={{ flexDirection: 'row', color: textw }}> */}
            {/* <Select
              value={trigger}
              className={'trigger' + (!isDarkMode ? 'dark' : 'unDark')}
              style={{
                background: gray,
                color: textw,
                borderRadius: 5,
                marginRight: 0,
                marginTop: -10,
                backgroundColor: theme === 'light' ? '#F8F4F0' : '#0C110E',
              }}
              bordered={false}
              allowClear={false}
              onChange={(e) => {
                console.log('trigger', e);
                setTrigger(e);
                mutateTradeStore({
                  ...tradeStore,
                  trigger_type: e,
                });
              }}
            >
              <Select.Option value="BIG">{'>='}</Select.Option>
              <Select.Option value="SML">{'<='}</Select.Option>
            </Select> */}
            <Input
              placeholder={''}
              value={
                tradeStore?.trigger_price ? tradeStore?.trigger_price : null
              }
              type={'text'}
              onChange={(e: any) => setTriggerPrice(e.target.value)}
              style={{
                background: gray,
                color: textw,
                border: `1px solid ${isMobile ? mobileTradeBorder : '#F87943'}`,
                padding: 10,
                width: '100%',
                backgroundColor: theme === 'light' ? '#F8F4F0' : '#0C110E',
              }}
            />
            {/* </View> */}
          </>
        ))}
    </OrderValueInputSection>
  );
};

export default React.memo(OrderPriceInput);
